<template>
    <div>
        <widget-container-modal />
        <PrimeToast position="bottom-right" />
        <AppConfirmDialog />
        <router-view
            :user="user"
            :organization="organization"
        ></router-view>
    </div>
</template>

<script>
import { container } from 'jenesius-vue-modal'
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import PrimeToast from 'primevue/toast'
import AppConfirmDialog from '@/components/AppConfirmDialog.vue'
import Permissions from '@/mixins/permissions'

export default defineComponent({
    components: { AppConfirmDialog, PrimeToast, WidgetContainerModal: container },
    mixins: [Permissions],
    computed: {
        ...mapGetters(['user', 'organization']),
    },
})
</script>
